import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const StickyNoteCTA = ({ price, ctaText }) => {
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show sticky note after scrolling 300px
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleClick = () => {
    navigate('/auth');
  };

  return (
    <div
      className={`fixed right-8 transition-all duration-500 ease-out z-50 ${
        isVisible ? 'top-24 opacity-100' : '-top-32 opacity-0'
      }`}
      style={{
        transform: isVisible ? 'rotate(2deg)' : 'rotate(2deg) translateY(-20px)',
      }}
    >
      <div
        className="relative cursor-pointer group"
        onClick={handleClick}
        style={{
          background: 'linear-gradient(135deg, #FFE5D0 0%, #FFDDB8 100%)',
          boxShadow: '0 6px 16px rgba(232, 93, 53, 0.2), 0 12px 32px rgba(232, 93, 53, 0.1)',
          padding: '24px 28px',
          minWidth: '200px',
          fontFamily: "'Inter', Arial, sans-serif",
        }}
      >
        {/* Tape effect at top */}
        <div
          className="absolute -top-3 left-1/2 transform -translate-x-1/2 w-16 h-6 opacity-30"
          style={{
            background: 'rgba(255, 255, 255, 0.4)',
            boxShadow: 'inset 0 1px 2px rgba(0, 0, 0, 0.1)',
          }}
        />

        <div className="text-center">
          <div
            className="font-bold text-lg mb-2"
            style={{
              color: '#C84B31',
              fontFamily: "'Caveat', cursive",
              fontSize: '1.4rem',
              lineHeight: '1.2',
            }}
          >
            {ctaText}
          </div>
          <div
            className="text-2xl font-black mb-3"
            style={{
              color: '#2C2823',
              fontFamily: "'Inter', Arial, sans-serif",
            }}
          >
            {price}
          </div>
          <div
            className="flex items-center justify-center gap-2 text-sm font-semibold group-hover:gap-3 transition-all"
            style={{ color: '#C84B31' }}
          >
            Start Here
            <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
          </div>
        </div>

        {/* Shadow for depth */}
        <div
          className="absolute inset-0 -z-10"
          style={{
            background: 'rgba(0, 0, 0, 0.1)',
            transform: 'translate(4px, 4px)',
            filter: 'blur(8px)',
          }}
        />
      </div>
    </div>
  );
};

export default StickyNoteCTA;
